module.exports = __webpack_public_path__ + "img/sale_tag.1c5b3a80.png";